import React, { useCallback, useEffect, useMemo, useState } from 'react';

import Header from '../../components/Header/Header';
import Button from '../../components/Button/Button';
import alert from '../../helpers/alert';
import extractErrorMessage from '../../utils/extractErrorMessage';
import icon from '../../assets/sidebar/cars.svg';
import styles from './priceList.module.css';
import {
  applyPriceList,
  getPriceList,
  getPriceMarks,
  rollbackPriceList,
  savePriceMeta,
  savePriceRules,
} from '../../api/prices';
import {
  ATTRS,
  NOT_SET,
  addBranch,
  buildTree,
  collapseNode,
  coverage,
  makeNode,
  normalizeEngineVolume,
  pricedInside,
  splitNode,
  subtreePaths,
  subtreeStats,
  treeToRules,
  unrepresentableRules,
  updateNode,
} from './priceTree';

const money = (v) => (v == null ? '' : Number(v).toLocaleString('ru-RU'));
const parseMoney = (v) => {
  const digits = String(v).replace(/\D/g, '');
  return digits ? Number(digits) : null;
};
const dateInput = (v) => (v ? String(v).slice(0, 10) : '');

const PriceList = () => {
  const [marks, setMarks] = useState([]);
  const [markId, setMarkId] = useState(null);
  const [data, setData] = useState(null);
  const [tree, setTree] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  // ÐÑÐºÐ°Ñ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ»Ðµ Ð½Ð°ÑÑÐ¾ÑÑÐµÐ³Ð¾ Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ: Ñ Ð¿ÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ° batchId
  // ÑÐ¾Ð¶Ðµ ÐµÑÑÑ, Ð½Ð¾ Ð·Ð° Ð½Ð¸Ð¼ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð·Ð°Ð¿Ð¸ÑÐ°Ð½Ð¾
  const [appliedBatch, setAppliedBatch] = useState(null);
  // Ð¡Ð²Ð¾ÑÐ°ÑÐ¸Ð²Ð°Ð½Ð¸Ðµ Ð²ÐµÑÐºÐ¸ Ñ Ð¿ÑÐ¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð½ÑÐ¼Ð¸ ÑÐµÐ½Ð°Ð¼Ð¸ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÐµÑÑÑ Ð²ÑÐ¾ÑÑÐ¼ ÐºÐ»Ð¸ÐºÐ¾Ð¼ â
  // ÑÐ¾Ñ Ð¶Ðµ Ð¿Ð°ÑÑÐµÑÐ½, ÑÑÐ¾ Ñ Ð¾ÑÐ¸ÑÑÐºÐ¸ ÑÑÐ¾ÐºÐ°: Ð±ÐµÐ· Ð¼Ð¾Ð´Ð°Ð»ÐºÐ¸, Ñ ÑÐ°Ð¼Ð¾ÑÐ±ÑÐ¾ÑÐ¾Ð¼
  const [collapseConfirm, setCollapseConfirm] = useState(null);
  // ÐÐ°ÐºÐ¸Ðµ Ð²ÐµÑÐºÐ¸ ÑÐ°ÑÐºÑÑÑÑ. ÐÐ¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ ÑÐ²ÑÑÐ½ÑÑÐ¾ Ð²ÑÑ: Ñ Kia Ð¿ÑÐ¸ Ð¿Ð¾Ð»Ð½Ð¾Ð¼ ÑÐ°Ð·Ð±Ð¸ÐµÐ½Ð¸Ð¸
  // Ð´ÐµÑÐµÐ²Ð¾ ÑÐ°Ð·ÑÐ°ÑÑÐ°ÐµÑÑÑ Ð´Ð¾ ~180 ÑÑÑÐ¾Ðº, Ð¸ Ð¸ÑÐºÐ°ÑÑ Ð² Ð½ÑÐ¼ Ð¾Ð´Ð½Ñ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð½ÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾
  const [openPaths, setOpenPaths] = useState(() => new Set());
  const [query, setQuery] = useState('');
  // ÐÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ Ð¼ÐµÐ½ÑÐµÑ ÑÐµÐ½Ñ ÑÐ¾ÑÐ½ÑÐ¼ Ð¼Ð°ÑÐ¸Ð½ Ð¸ ÑÑÐ¾Ð¸Ñ ÑÑÐ´Ð¾Ð¼ Ñ Ð±ÐµÐ·Ð¾Ð±Ð¸Ð´Ð½ÑÐ¼Ð¸ ÐºÐ½Ð¾Ð¿ÐºÐ°Ð¼Ð¸ â
  // Ð¾Ð´Ð½Ð¾Ð³Ð¾ ÐºÐ»Ð¸ÐºÐ° Ð´Ð»Ñ ÑÑÐ¾Ð³Ð¾ Ð¼Ð°Ð»Ð¾. ÐÐµÑÐ²ÑÐ¹ ÐºÐ»Ð¸Ðº ÑÑÐ¸ÑÐ°ÐµÑ Ð¿ÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ Ð¸ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ
  // ÑÐ¸ÑÐ»Ð¾ Ð¿ÑÑÐ¼Ð¾ Ð½Ð° ÐºÐ½Ð¾Ð¿ÐºÐµ, Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð²ÑÐ¾ÑÐ¾Ð¹
  const [applyConfirm, setApplyConfirm] = useState(null);
  // Ð§ÐµÑÐ½Ð¾Ð²Ð¸ÐºÐ¸ ÑÑÑÐ½Ð¾Ð³Ð¾ Ð²Ð²Ð¾Ð´Ð° Ð²ÐµÑÐ¾Ðº (Ð³Ð¾Ð´, Ð¾Ð±ÑÑÐ¼) â Ð¿Ð¾ ÐºÐ»ÑÑÑ Ð²ÐµÑÐºÐ¸, ÑÑÐ¾Ð±Ñ ÑÐ¾ÑÐµÐ´Ð½Ð¸Ðµ
  // ÑÑÑÐ¾ÐºÐ¸ Ð½Ðµ Ð´ÐµÐ»Ð¸Ð»Ð¸ Ð¾Ð´Ð½Ð¾ Ð¿Ð¾Ð»Ðµ
  const [addDraft, setAddDraft] = useState({});

  useEffect(() => {
    getPriceMarks()
      .then((res) => {
        setMarks(res.data || []);
        // ÐÐ°Ð³ÑÑÐ·ÐºÑ Ð·Ð´ÐµÑÑ Ð½Ðµ ÑÐ½Ð¸Ð¼Ð°ÐµÐ¼: ÑÐ»ÐµÐ´Ð¾Ð¼ Ð³ÑÑÐ·Ð¸ÑÑÑ Ð¿ÑÐ°Ð¹Ñ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð¼Ð°ÑÐºÐ¸, Ð¸ Ð¼ÐµÐ¶Ð´Ñ
        // Ð´Ð²ÑÐ¼Ñ Ð·Ð°Ð¿ÑÐ¾ÑÐ°Ð¼Ð¸ ÑÐºÑÐ°Ð½ Ð½Ð° ÐºÐ°Ð´Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð» Â«Ð½ÐµÑ Ð¼Ð°ÑÐ¸Ð½ Ð² ÑÑÐ¾ÐºÐµÂ» Ð±ÐµÐ· Ð´Ð°Ð½Ð½ÑÑ
        if (res.data?.length) setMarkId(res.data[0].markId);
        else setLoading(false);
      })
      .catch((err) => {
        alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¼Ð°ÑÐ¾Ðº');
        setLoading(false);
      });
  }, []);

  const load = useCallback((id) => {
    setLoading(true);
    setPreview(null);
    setAppliedBatch(null);
    setOpenPaths(new Set());
    setQuery('');
    setApplyConfirm(null);
    getPriceList(id)
      .then((res) => {
        setData(res.data);
        setTree(buildTree(res.data.stock || [], res.data.rules || []));
      })
      .catch((err) => {
        // ÐÐ½Ð°ÑÐµ Ð¿Ð¾Ð´ Ð½Ð¾Ð²Ð¾Ð¹ Ð¼Ð°ÑÐºÐ¾Ð¹ Ð¾ÑÑÐ°Ð»Ð¾ÑÑ Ð±Ñ Ð´ÐµÑÐµÐ²Ð¾ Ð¿ÑÐµÐ´ÑÐ´ÑÑÐµÐ¹ â Ð¸ ÑÐ¾ÑÑÐ°Ð½Ð¸Ð»Ð¾ÑÑ Ð±Ñ Ð² Ð½ÐµÑ
        setData(null);
        setTree([]);
        alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð¿ÑÐ°Ð¹Ñ');
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (markId) load(markId);
  }, [markId, load]);

  useEffect(() => {
    if (!collapseConfirm) return undefined;
    const timer = setTimeout(() => setCollapseConfirm(null), 4000);
    return () => clearTimeout(timer);
  }, [collapseConfirm]);

  useEffect(() => {
    if (!applyConfirm) return undefined;
    const timer = setTimeout(() => setApplyConfirm(null), 6000);
    return () => clearTimeout(timer);
  }, [applyConfirm]);

  const names = useMemo(() => {
    const models = {};
    (data?.models || []).forEach((m) => {
      models[m.id] = m.name;
    });
    const compl = {};
    (data?.complectations || []).forEach((c) => {
      compl[c.id] = c.title;
    });
    const wd = {};
    (data?.wd || []).forEach((w) => {
      wd[w.id] = w.title;
    });
    return { models, compl, wd };
  }, [data]);

  const label = (fixed, depth) => {
    if (depth === 0) return names.models[fixed.modelId] || `ÐÐ¾Ð´ÐµÐ»Ñ #${fixed.modelId}`;
    const attr = Object.keys(fixed)[Object.keys(fixed).length - 1];
    const value = fixed[attr];
    if (attr === 'complectationId') return value ? names.compl[value] || `#${value}` : NOT_SET;
    if (attr === 'wdId') return value ? names.wd[value] || `#${value}` : NOT_SET;
    return String(value ?? '').length ? String(value) : NOT_SET;
  };

  const stats = useMemo(() => coverage(tree), [tree]);

  const pathKey = (node) => JSON.stringify(node.fixed);
  const isOpen = (node) => openPaths.has(pathKey(node));
  // Ð Ð°ÑÐºÑÑÐ²Ð°ÐµÐ¼ Ð¸ ÑÐ²Ð¾ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼ Ð²ÐµÑÐºÑ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼. ÐÐ¾ ÑÑÐ¾Ð²Ð½Ñ Ð·Ð° ÐºÐ»Ð¸Ðº Ð±ÑÐ»Ð¾ Ð¼ÑÑÐµÐ½Ð¸ÐµÐ¼:
  // Ñ Carnival ÑÐµÐ½Ð° ÑÑÐ¾Ð¸Ñ Ð½Ð° Ð¾Ð±ÑÑÐ¼Ðµ, ÑÐ¾ ÐµÑÑÑ Ð½Ð° ÑÑÐµÑÑÐµÐ¼ ÑÑÐ¾Ð²Ð½Ðµ, Ð¸ Ð¿ÐµÑÐ²ÑÐµ Ð´Ð²Ð°
  // ÐºÐ»Ð¸ÐºÐ° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»Ð¸ ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÑÐ¾ÐºÐ¸ Ñ Ð¿ÑÐ¾ÑÐµÑÐºÐ¾Ð¼
  const toggleOpen = (node) =>
    setOpenPaths((prev) => {
      const next = new Set(prev);
      const paths = subtreePaths(node);
      if (next.has(paths[0])) paths.forEach((p) => next.delete(p));
      else paths.forEach((p) => next.add(p));
      return next;
    });

  // ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ Ð¼Ð¾Ð´ÐµÐ»Ð¸. ÐÐ¾Ð³Ð´Ð° ÑÐ¾Ð²Ð¿Ð°Ð»Ð° ÑÐ¾Ð²Ð½Ð¾ Ð¾Ð´Ð½Ð° â ÑÑÐ°Ð·Ñ ÑÐ°ÑÐºÑÑÐ²Ð°ÐµÐ¼ ÐµÑ:
  // ÑÑÐ¾ Ð¸ ÐµÑÑÑ ÑÐ¸Ð¿Ð¾Ð²Ð¾Ð¹ ÑÑÐµÐ½Ð°ÑÐ¸Ð¹ Â«Ð¸ÑÑ Ð¾Ð´Ð½Ñ Ð¼Ð°ÑÐºÑ, ÑÑÐ¾Ð±Ñ Ð¿Ð¾Ð¿ÑÐ°Ð²Ð¸ÑÑ ÑÐµÐ½ÑÂ»
  const visibleTree = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return tree;
    return tree.filter((n) => label(n.fixed, 0).toLowerCase().includes(q));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tree, query, names]);

  useEffect(() => {
    if (visibleTree.length === 1 && query.trim()) {
      // ÐÐ°ÑÐ»Ð¸ Ð¾Ð´Ð½Ñ Ð¼Ð¾Ð´ÐµÐ»Ñ â Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÐµÑ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼, Ð° Ð½Ðµ Ð¿ÐµÑÐ²ÑÐ¹ ÑÑÐ¾Ð²ÐµÐ½Ñ
      setOpenPaths((prev) => {
        const next = new Set(prev);
        subtreePaths(visibleTree[0]).forEach((p) => next.add(p));
        return next;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleTree.length, query]);

  const patch = (node, fn) => {
    // ÐÐµÑÐµÐ²Ð¾ Ð¸Ð·Ð¼ÐµÐ½Ð¸Ð»Ð¾ÑÑ â Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð½Ð½Ð¾Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð±Ð¾Ð»ÑÑÐµ Ð½Ðµ Ð¿ÑÐ¾ ÑÑÐ¾Ñ Ð¿ÑÐ°Ð¹Ñ
    setApplyConfirm(null);
    setTree((prev) => updateNode(prev, node, fn));
  };

  // Ð Ð°ÑÐºÑÑÐ²Ð°ÐµÐ¼ ÑÑÐ°Ð·Ñ: Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð²ÑÐ±ÑÐ°Ð» ÑÐ°Ð·Ð±Ð¸ÐµÐ½Ð¸Ðµ, ÑÑÐ¾Ð±Ñ ÑÐ²Ð¸Ð´ÐµÑÑ ÑÐµÐ·ÑÐ»ÑÑÐ°Ñ, Ð° Ð½Ðµ
  // ÑÑÐ¾Ð±Ñ Ð¿Ð¾Ð»ÑÑÐ¸ÑÑ ÑÐµÐ²ÑÐ¾Ð½ Ð¸ Ð²ÑÐ¾ÑÐ¾Ð¹ ÐºÐ»Ð¸Ðº
  const onSplit = (node, attr) => {
    patch(node, (n) => splitNode(n, attr, data.stock, data.rules));
    setOpenPaths((prev) => new Set(prev).add(pathKey(node)));
  };

  const onCollapse = (node) => {
    if (pricedInside(node) && collapseConfirm !== node) {
      setCollapseConfirm(node);
      return;
    }
    setCollapseConfirm(null);
    patch(node, collapseNode);
  };

  const onPrice = (node, raw) => patch(node, (n) => ({ ...n, price: parseMoney(raw) }));

  // ÐÐ°ÑÐ¸Ð°Ð½ÑÑ, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð¼Ð¾Ð¶Ð½Ð¾ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð²ÐµÑÐºÐ¾Ð¹ Ð²ÑÑÑÐ½ÑÑ: Ð²ÑÑ, ÑÑÐ¾ ÐµÑÑÑ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ,
  // Ð¼Ð¸Ð½ÑÑ ÑÐ¾, ÑÑÐ¾ ÑÐ¶Ðµ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ð¾. ÐÐ»Ñ Ð³Ð¾Ð´Ð° Ð¸ Ð¾Ð±ÑÑÐ¼Ð° ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ° Ð½ÐµÑ â ÑÐ°Ð¼ Ð²Ð²Ð¾Ð´ ÑÑÐºÐ°Ð¼Ð¸
  const missingValues = (node) => {
    const attr = node.by;
    const shown = new Set(node.kids.map((k) => String(k.fixed[attr] ?? '')));
    if (attr === 'wdId')
      return (data?.wd || [])
        .filter((w) => !shown.has(String(w.id)))
        .map((w) => ({ value: w.id, title: w.title }));
    if (attr === 'complectationId')
      return (data?.complectations || [])
        .filter((c) => c.modelId === node.fixed.modelId && !shown.has(String(c.id)))
        .map((c) => ({ value: c.id, title: c.title }));
    return null; // Ð³Ð¾Ð´ Ð¸ Ð¾Ð±ÑÑÐ¼ â ÑÐ²Ð¾Ð±Ð¾Ð´Ð½ÑÐ¹ Ð²Ð²Ð¾Ð´
  };

  const submitDraft = (node) => {
    const draft = (addDraft[pathKey(node)] || '').trim();
    if (!draft) return;
    onAddBranch(node, draft);
    setAddDraft((prev) => ({ ...prev, [pathKey(node)]: '' }));
  };

  const onAddBranch = (node, rawValue) => {
    const attr = node.by;
    let value;
    if (attr === 'wdId' || attr === 'complectationId') {
      value = Number(rawValue);
    } else if (attr === 'engineVolume') {
      // ÐÑÐ¸Ð²Ð¾Ð´Ð¸Ð¼ Ðº ÑÐ¾Ð¼Ñ Ð¶Ðµ Ð²Ð¸Ð´Ñ, ÑÑÐ¾ Ð¸ Ð²ÐµÑÐºÐ¸ ÑÑÐ¾ÐºÐ°: Ð¸Ð½Ð°ÑÐµ Â«2500Â» Ð½Ðµ ÑÐ¾Ð²Ð¿Ð°Ð»Ð¾ Ð±Ñ
      // Ð½Ð¸ Ñ Ð¾Ð´Ð½Ð¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ð¾Ð¹ Ð¸ Ð²ÐµÑÐºÐ° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»Ð° Ð±Ñ Â«Ð½ÐµÑ Ð² ÑÑÐ¾ÐºÐµÂ» Ð´Ð¾ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ñ
      value = normalizeEngineVolume(rawValue);
      if (!value) {
        alert.error(`ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ°Ð·Ð¾Ð±ÑÐ°ÑÑ Ð¾Ð±ÑÑÐ¼ Â«${rawValue}Â». Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð»Ð¸ÑÑÑ (2.0) Ð¸Ð»Ð¸ ÑÐ¼Â³ (1975)`);
        return;
      }
    } else {
      value = String(rawValue).trim();
    }
    if (!value) return;
    patch(node, (n) => addBranch(n, attr, value, data.stock, data.rules));
    setOpenPaths((prev) => new Set(prev).add(pathKey(node)));
  };

  const saveRules = async () => {
    setBusy(true);
    try {
      // ÐÐµÑÐµÐ²Ð¾ ÑÑÑÐ¾Ð¸ÑÑÑ Ð¸Ð· ÑÑÐ¾ÐºÐ° Ð Ð¸Ð· Ð¿ÑÐ°Ð²Ð¸Ð», Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ñ Ð¼Ð¾Ð´ÐµÐ»ÑÑ Ð¾ÑÑÐ°Ð¶Ð°ÐµÑ
      // ÑÐµÐ»Ð¸ÐºÐ¾Ð¼. ÐÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ â Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð±ÐµÐ· modelId (Â«Ð½Ð° Ð²ÑÑ Ð¼Ð°ÑÐºÑÂ»): Ð²ÐµÑÑÐ½Ð¸Ð¹ ÑÑÐ¾Ð²ÐµÐ½Ñ
      // Ð´ÐµÑÐµÐ²Ð° Ð²ÑÐµÐ³Ð´Ð° Ð¼Ð¾Ð´ÐµÐ»Ñ, Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ ÐµÐ³Ð¾ Ð½ÐµÐ³Ð´Ðµ. ÐÐ¾Ð¿Ð¸ÑÑÐ²Ð°ÐµÐ¼ ÑÐ°ÐºÐ¸Ðµ Ð¾Ð±ÑÐ°ÑÐ½Ð¾, Ð¸Ð½Ð°ÑÐµ
      // ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ðµ Ð¼Ð¾Ð»ÑÐ° ÑÑÐ¸ÑÐ°Ð»Ð¾ Ð±Ñ Ð¸Ñ, Ð²ÐµÐ´Ñ Ð½Ð°Ð±Ð¾Ñ Ð·Ð°Ð¼ÐµÐ½ÑÐµÑÑÑ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼
      const payload = [...treeToRules(tree), ...unrepresentableRules(data.rules || [])];
      await savePriceRules(markId, payload);
      alert.success(`ÐÑÐ°Ð¹Ñ ÑÐ¾ÑÑÐ°Ð½ÑÐ½: Ð¿ÑÐ°Ð²Ð¸Ð» â ${payload.length}`);
      load(markId);
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¿ÑÐ°Ð¹Ñ');
    } finally {
      setBusy(false);
    }
  };

  const saveMeta = async (patchMeta) => {
    const next = { ...data.priceList, ...patchMeta };
    setData({ ...data, priceList: next });
    try {
      await savePriceMeta(markId, {
        docNumber: next.docNumber,
        docDate: next.docDate,
        docUrl: next.docUrl,
      });
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÑ ÑÐ°Ð¿ÐºÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°');
    }
  };

  const runPreview = async () => {
    setBusy(true);
    try {
      const res = await applyPriceList(markId, true);
      setPreview(res.data);
      setAppliedBatch(null);
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿Ð¾ÑÑÐ¸ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ');
    } finally {
      setBusy(false);
    }
  };

  const runApply = async () => {
    // ÐÐµÑÐ²ÑÐ¹ ÐºÐ»Ð¸Ðº â Ð¿ÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ: ÑÑÐ¸ÑÐ°ÐµÐ¼, ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¼Ð°ÑÐ¸Ð½ Ð·Ð°Ð´ÐµÐ½ÐµÐ¼, Ð¸ Ð¶Ð´ÑÐ¼ Ð²ÑÐ¾ÑÐ¾Ð³Ð¾
    if (!applyConfirm) {
      setBusy(true);
      try {
        const res = await applyPriceList(markId, true);
        setPreview(res.data);
        setAppliedBatch(null);
        setApplyConfirm(res.data);
      } catch (err) {
        alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿Ð¾ÑÑÐ¸ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ');
      } finally {
        setBusy(false);
      }
      return;
    }
    setApplyConfirm(null);
    setBusy(true);
    try {
      const res = await applyPriceList(markId, false);
      alert.success(`ÐÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¾: Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¾ Ð¼Ð°ÑÐ¸Ð½ â ${res.data.changed}`);
      setPreview(res.data);
      setAppliedBatch(res.data.changed > 0 ? res.data.batchId : null);
      load(markId);
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ Ð¿ÑÐ°Ð¹Ñ');
    } finally {
      setBusy(false);
    }
  };

  const runRollback = async () => {
    if (!appliedBatch) return;
    setBusy(true);
    try {
      const res = await rollbackPriceList(appliedBatch);
      alert.success(`ÐÑÐºÐ°Ñ: Ð²Ð¾Ð·Ð²ÑÐ°ÑÐµÐ½Ð¾ Ð¼Ð°ÑÐ¸Ð½ â ${res.data.reverted}`);
      setPreview(null);
      setAppliedBatch(null);
      load(markId);
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐºÐ°ÑÐ¸ÑÑ Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ');
    } finally {
      setBusy(false);
    }
  };

  const renderNode = (node, depth, inherited) => {
    const key = pathKey(node);
    const count = node.groups.reduce((s, g) => s + g.count, 0);
    // ÐÐµÑÐºÐ° Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð¿ÑÑÑÐ¾Ð¹: ÐµÑ Ð·Ð°Ð²ÐµÐ»Ð¸ Ð¿Ð¾Ð´ Ð²Ð°ÑÐ¸Ð°Ð½Ñ Ð¸Ð· Ð¿ÑÐ¸ÐºÐ°Ð·Ð°, ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð² ÑÑÐ¾ÐºÐµ
    // ÐµÑÑ Ð½ÐµÑ. Math.min Ð¾Ñ Ð¿ÑÑÑÐ¾Ð³Ð¾ Ð¼Ð°ÑÑÐ¸Ð²Ð° Ð´Ð°ÑÑ Infinity â Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð¿ÑÐ¾ÑÐµÑÐº
    const hasCars = node.groups.length > 0;
    const lo = hasCars ? Math.min(...node.groups.map((g) => g.minPrice)) : null;
    const hi = hasCars ? Math.max(...node.groups.map((g) => g.maxPrice)) : null;
    const free = ATTRS.filter((a) => !(a.key in node.fixed));
    const isNotSet = label(node.fixed, depth) === NOT_SET;
    const lost = pricedInside(node);
    const effective = node.price != null ? node.price : inherited;
    const open = isOpen(node);
    // Ð Ð°Ð·Ð±Ð¸ÑÐ°Ñ Ð²ÐµÑÐºÐ° Ð±ÐµÐ· ÐµÐ´Ð¸Ð½Ð¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ñ Ð´ÐµÑÐµÐ¹ Ð½Ðµ Ð¸Ð¼ÐµÐµÑ â Ð½Ð¾ ÑÐ°ÑÐºÑÑÐ²Ð°ÑÑ ÐµÑ Ð½Ð°Ð´Ð¾:
    // Ð²Ð½ÑÑÑÐ¸ ÑÑÑÐ¾ÐºÐ° Â«Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð²Ð°ÑÐ¸Ð°Ð½ÑÂ», ÑÐ°Ð´Ð¸ ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ ÑÐ°Ð·Ð±Ð¸ÐµÐ½Ð¸Ðµ Ð¸ Ð´ÐµÐ»Ð°Ð»Ð¸
    const openable = node.kids.length > 0 || !!node.by;
    // ÐÐ½Ð°ÑÐºÐ¸ â Ð²ÐµÐ·Ð´Ðµ, Ð³Ð´Ðµ ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ð¼Ð¾Ðµ Ð²ÐµÑÐºÐ¸ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ð¾: Ð¸ Ð½Ð° ÑÐ²ÑÑÐ½ÑÑÐ¾Ð¹ Ð²ÐµÑÐºÐµ, Ð¸ Ð½Ð°
    // Ð»Ð¸ÑÑÐµ. ÐÐ½Ð°ÑÐµ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð±ÐµÐ· ÐµÐ´Ð¸Ð½Ð¾Ð³Ð¾ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð²ÑÐ³Ð»ÑÐ´ÐµÐ»Ð° Ð±Ñ ÐºÐ°Ðº Ð³Ð¾ÑÐ¾Ð²Ð°Ñ, ÑÐ¾ÑÑ Ð¸Ð¼ÐµÐ½Ð½Ð¾
    // Ð¸Ð· ÑÐ°ÐºÐ¸Ñ Ð¸ ÑÐºÐ»Ð°Ð´ÑÐ²Ð°ÐµÑÑÑ ÑÑÑÑÑÐ¸Ðº Â«Ð±ÐµÐ· ÑÐµÐ½ÑÂ». Ð£ ÑÐ°ÑÐºÑÑÑÐ¾Ð¹ Ð²ÐµÑÐºÐ¸ Ð·Ð½Ð°ÑÐºÐ¸ Ð½Ðµ
    // ÑÐ¸ÑÑÐµÐ¼ â ÑÐ¾ Ð¶Ðµ ÑÐ°Ð¼Ð¾Ðµ Ð²Ð¸Ð´Ð½Ð¾ Ð¿Ð¾ÑÑÑÐ¾ÑÐ½Ð¾ Ð½Ð¸Ð¶Ðµ
    // Ð¡ÑÐ¸ÑÐ°ÐµÐ¼ Ð²ÑÐµÐ³Ð´Ð°, Ð° Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ°Ð´Ð¸ Ð·Ð½Ð°ÑÐºÐ°: Ð¿Ð¾ ÑÑÐ¾Ð¹ Ð¶Ðµ ÑÐ¸ÑÑÐµ ÐºÑÐ°ÑÐ½ÐµÐµÑ Ð¿Ð¾Ð»Ðµ
    // ÑÐµÐ½Ñ. ÐÐ° ÑÐ°ÑÐºÑÑÑÐ¾Ð¹ Ð²ÐµÑÐºÐµ Ð·Ð½Ð°ÑÐºÐ¾Ð² Ð½ÐµÑ, Ð¸ Ð±ÐµÐ· Ð¿Ð¾Ð´ÑÐ²ÐµÑÐºÐ¸ ÑÐ»ÐµÐ´ Ð´ÑÑÑ ÑÐµÑÑÐ»ÑÑ
    // ÑÐ¾Ð²Ð½Ð¾ Ð² ÑÐ¾Ñ Ð¼Ð¾Ð¼ÐµÐ½Ñ, ÐºÐ¾Ð³Ð´Ð° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÐ°Ð·Ð²Ð¾ÑÐ°ÑÐ¸Ð²Ð°Ð» Ð´ÐµÑÐµÐ²Ð¾, Ð¸Ð´Ñ Ðº Ð½ÐµÐ¹
    const rowStats = subtreeStats(node, inherited);
    const badge = open ? null : rowStats;

    return (
      <React.Fragment key={key}>
        <div
          className={[
            styles.row,
            isNotSet ? styles.rowNotSet : '',
            depth === 0 ? styles.rowRoot : '',
            openable ? styles.rowOpenable : '',
          ]
            .filter(Boolean)
            .join(' ')}
          onClick={(e) => {
            // ÐÐ»Ð¸Ðº Ð¿Ð¾ ÑÑÑÐ¾ÐºÐµ ÑÐ°ÑÐºÑÑÐ²Ð°ÐµÑ Ð²ÐµÑÐºÑ, Ð½Ð¾ Ð½Ðµ Ð¾ÑÐ±Ð¸ÑÐ°ÐµÑ ÐºÐ»Ð¸ÐºÐ¸ Ñ Ð¿Ð¾Ð»Ñ ÑÐµÐ½Ñ Ð¸
            // ÐºÐ¾Ð½ÑÑÐ¾Ð»Ð¾Ð² â Ð¸Ð½Ð°ÑÐµ Ð½ÐµÐ»ÑÐ·Ñ Ð±ÑÐ»Ð¾ Ð±Ñ Ð¿Ð¾ÑÑÐ°Ð²Ð¸ÑÑ ÐºÑÑÑÐ¾Ñ Ð² ÑÐµÐ½Ñ
            if (!openable) return;
            if (e.target.closest('input, select, button')) return;
            toggleOpen(node);
          }}
        >
          <span className={depth === 0 ? styles.nameRoot : styles.name}>
            {Array.from({ length: depth }, (_, i) => (
              <span key={i} className={styles.rail} />
            ))}
            {openable ? (
              <button
                type="button"
                className={styles.chevron}
                aria-expanded={open}
                onClick={() => toggleOpen(node)}
                title={open ? 'Ð¡Ð²ÐµÑÐ½ÑÑÑ Ð²ÐµÑÐºÑ' : 'Ð Ð°Ð·Ð²ÐµÑÐ½ÑÑÑ Ð²ÐµÑÐºÑ'}
              >
                {open ? 'â¾' : 'â¸'}
              </button>
            ) : (
              <span className={styles.chevronGap} />
            )}
            {label(node.fixed, depth)}
            {badge?.withoutPrice > 0 && (
              <span className={styles.badgeBad}>{badge.withoutPrice} Ð±ÐµÐ· ÑÐµÐ½Ñ</span>
            )}
            {badge?.changing > 0 && (
              <span className={styles.badge}>{badge.changing} Ð½Ðµ Ð¿Ð¾ Ð¿ÑÐ°Ð¹ÑÑ</span>
            )}
          </span>
          <span className={styles.count}>{count}</span>
          <span className={`${styles.range} ${hasCars && lo !== hi ? styles.rangeSpread : ''}`}>
            {!hasCars
              ? 'Ð½ÐµÑ Ð² ÑÑÐ¾ÐºÐµ'
              : lo === hi
              ? money(lo)
              : `${(lo / 1e6).toFixed(1)}â${(hi / 1e6).toFixed(1)} Ð¼Ð»Ð½`}
          </span>
          <input
            className={[styles.price, rowStats.withoutPrice > 0 ? styles.priceEmpty : '']
              .filter(Boolean)
              .join(' ')}
            aria-label={`Ð¦ÐµÐ½Ð°: ${label(node.fixed, depth)}`}
            value={money(node.price)}
            placeholder={effective != null ? money(effective) : 'â'}
            // ÐÑÐ°ÑÐ½ÑÐ¹ ÑÐ²ÐµÑ ÑÐ°Ð¼ Ð¿Ð¾ ÑÐµÐ±Ðµ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¾Ð±ÑÑÑÐ½ÑÐµÑ Ð¸ Ð½Ðµ Ð²Ð¸Ð´ÐµÐ½ ÑÐµÐ¼, ÐºÑÐ¾ ÐµÐ³Ð¾
            // Ð½Ðµ ÑÐ°Ð·Ð»Ð¸ÑÐ°ÐµÑ: Ð½Ð° hover Ð¿Ð¾Ð»Ðµ Ð³Ð¾Ð²Ð¾ÑÐ¸Ñ, ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¼Ð°ÑÐ¸Ð½ Ð¾ÑÑÐ°Ð»Ð¸ÑÑ Ð±ÐµÐ· ÑÐµÐ½Ñ
            title={
              rowStats.withoutPrice > 0
                ? `ÐÐ°ÑÐ¸Ð½ Ð±ÐµÐ· ÑÐµÐ½Ñ: ${rowStats.withoutPrice}`
                : node.price == null && effective != null
                ? 'Ð¦ÐµÐ½Ð° ÑÐ½Ð°ÑÐ»ÐµÐ´Ð¾Ð²Ð°Ð½Ð° Ð¾Ñ Ð²ÐµÑÐºÐ¸ Ð²ÑÑÐµ'
                : undefined
            }
            onChange={(e) => onPrice(node, e.target.value)}
          />
          <span className={styles.control}>
            {node.by ? (
              <button
                type="button"
                className={collapseConfirm === node ? styles.miniDanger : styles.mini}
                onClick={() => onCollapse(node)}
                title="Ð£Ð±ÑÐ°ÑÑ ÑÐ°Ð·Ð±Ð¸ÐµÐ½Ð¸Ðµ: Ð²ÐµÑÐºÐ° ÑÐ½Ð¾Ð²Ð° ÑÑÐ°Ð½ÐµÑ Ð¾Ð´Ð½Ð¾Ð¹ ÑÑÑÐ¾ÐºÐ¾Ð¹"
              >
                {collapseConfirm === node ? `Ð¿Ð¾ÑÐµÑÑÑÑ ${lost} ÑÐµÐ½?` : 'ÑÐ±ÑÐ°ÑÑ ÑÐ°Ð·Ð±Ð¸ÐµÐ½Ð¸Ðµ'}
              </button>
            ) : (
              free.length > 0 && (
                <select
                  className={styles.split}
                  aria-label="Ð Ð°Ð·Ð±Ð¸ÑÑ Ð²ÐµÑÐºÑ"
                  value=""
                  onChange={(e) => e.target.value && onSplit(node, e.target.value)}
                >
                  <option value="">ÑÐ°Ð·Ð±Ð¸ÑÑ Ð¿Ð¾â¦</option>
                  {/* Ð Ð°Ð·Ð±Ð¸Ð²Ð°ÑÑ Ð¼Ð¾Ð¶Ð½Ð¾ Ð²ÑÐµÐ³Ð´Ð°, Ð´Ð°Ð¶Ðµ ÐºÐ¾Ð³Ð´Ð° Ð² ÑÑÐ¾ÐºÐµ Ð¾Ð´Ð¸Ð½ Ð²Ð°ÑÐ¸Ð°Ð½Ñ Ð¸Ð»Ð¸ Ð½Ð¸
                      Ð¾Ð´Ð½Ð¾Ð³Ð¾: Ð¿ÑÐ¸ÐºÐ°Ð· ÑÐ°Ð·Ð»Ð¸ÑÐ°ÐµÑ ÑÐ¾, ÑÐµÐ³Ð¾ Ð² Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸ ÐµÑÑ Ð½ÐµÑ, Ð¸ Ð·Ð°Ð¿ÑÐµÑ
                      Ð½Ðµ Ð´Ð°Ð²Ð°Ð» Ð·Ð°Ð²ÐµÑÑÐ¸ ÑÐ°ÐºÑÑ ÑÐµÐ½Ñ Ð·Ð°ÑÐ°Ð½ÐµÐµ. Ð§Ð¸ÑÐ»Ð¾ ÑÑÐ´Ð¾Ð¼ â ÑÐ¿ÑÐ°Ð²ÐºÐ°,
                      ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð²ÐµÑÐ¾Ðº Ð´Ð°ÑÑ ÑÐ°Ð¼ ÑÑÐ¾Ðº */}
                  {free.map((a) => {
                    const variants = new Set(node.groups.map((g) => String(g[a.key] ?? ''))).size;
                    return (
                      <option key={a.key} value={a.key}>
                        {a.title} â Ð² ÑÑÐ¾ÐºÐµ {variants}
                      </option>
                    );
                  })}
                </select>
              )
            )}
          </span>
        </div>
        {open && node.kids.map((k) => renderNode(k, depth + 1, effective))}
        {open && node.by && renderAddBranch(node, depth + 1)}
      </React.Fragment>
    );
  };

  // ÐÑÐ¸ÐºÐ°Ð· Ð½ÐµÑÐµÐ´ÐºÐ¾ Ð½Ð°Ð·ÑÐ²Ð°ÐµÑ Ð²Ð°ÑÐ¸Ð°Ð½Ñ, ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð² Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸ ÐµÑÑ Ð½ÐµÑ. ÐÐµÐ· ÑÑÐ¾Ð¹ ÑÑÑÐ¾ÐºÐ¸
  // ÑÐµÐ½Ñ Ð½Ð° Ð½ÐµÐ³Ð¾ Ð½ÐµÐ»ÑÐ·Ñ Ð±ÑÐ»Ð¾ Ð·Ð°Ð²ÐµÑÑÐ¸ Ð·Ð°ÑÐ°Ð½ÐµÐµ, Ð¸ Ð¿ÑÐ¸ÐµÑÐ°Ð²ÑÐ°Ñ Ð¼Ð°ÑÐ¸Ð½Ð° Ð¼Ð¾Ð»ÑÐ°
  // Ð½Ð°ÑÐ»ÐµÐ´Ð¾Ð²Ð°Ð»Ð° ÑÐµÐ½Ñ ÑÐ¾Ð´Ð¸ÑÐµÐ»ÑÑÐºÐ¾Ð¹ Ð²ÐµÑÐºÐ¸ â ÑÐ¾Ð²Ð½Ð¾ ÑÐ° Ð¾ÑÐ¸Ð±ÐºÐ°, ÑÐ°Ð´Ð¸ ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ Ð²ÑÑ Ð·Ð°ÑÐµÐ²Ð°Ð»Ð¾ÑÑ
  const renderAddBranch = (node, depth) => {
    const options = missingValues(node);
    const attrTitle = ATTRS.find((a) => a.key === node.by)?.title || '';
    if (options && options.length === 0) return null;

    return (
      <div className={styles.addRow} style={{ paddingLeft: depth * 18 + 22 }}>
        {options ? (
          <select
            className={styles.split}
            aria-label="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð²Ð°ÑÐ¸Ð°Ð½Ñ"
            value=""
            onChange={(e) => e.target.value && onAddBranch(node, e.target.value)}
          >
            <option value="">+ {attrTitle}, ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð½ÐµÑ Ð² ÑÑÐ¾ÐºÐµâ¦</option>
            {options.map((o) => (
              <option key={o.value} value={o.value}>
                {o.title}
              </option>
            ))}
          </select>
        ) : (
          // Ð¡Ð²Ð¾Ð±Ð¾Ð´Ð½ÑÐ¹ Ð²Ð²Ð¾Ð´ (Ð³Ð¾Ð´, Ð¾Ð±ÑÑÐ¼) â Ñ ÑÐ²Ð½Ð¾Ð¹ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹: Ð¿Ð¾Ð»Ð°Ð³Ð°ÑÑÑÑ Ð½Ð° Ð½ÐµÐ²Ð¸Ð´Ð¸Ð¼Ð¾Ðµ
          // Ð½Ð°Ð¶Ð°ÑÐ¸Ðµ Enter Ð½ÐµÐ»ÑÐ·Ñ, Ð¾ Ð½ÑÐ¼ Ð½Ð¸ÐºÑÐ¾ Ð½Ðµ Ð´Ð¾Ð³Ð°Ð´Ð°ÐµÑÑÑ
          <>
            <input
              className={styles.addInput}
              placeholder={`${attrTitle}, ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð½ÐµÑ Ð² ÑÑÐ¾ÐºÐµ`}
              value={addDraft[pathKey(node)] || ''}
              onChange={(e) =>
                setAddDraft((prev) => ({ ...prev, [pathKey(node)]: e.target.value }))
              }
              onKeyDown={(e) => e.key === 'Enter' && submitDraft(node)}
            />
            <button
              type="button"
              className={styles.mini}
              disabled={!(addDraft[pathKey(node)] || '').trim()}
              onClick={() => submitDraft(node)}
            >
              Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ
            </button>
          </>
        )}
      </div>
    );
  };

  // ÐÐµÑÑÐ½Ð¸Ð¹ ÑÑÐ¾Ð²ÐµÐ½Ñ Ð´ÐµÑÐµÐ²Ð° â Ð¼Ð¾Ð´ÐµÐ»Ð¸, Ð¸ ÑÑÐ´Ð° renderAddBranch Ð½Ðµ Ð´Ð¾ÑÑÐ°ÑÑ: Ñ ÐºÐ¾ÑÐ½ÐµÐ¹
  // Ð½ÐµÑ ÑÐ¾Ð´Ð¸ÑÐµÐ»ÑÑÐºÐ¾Ð³Ð¾ ÑÐ·Ð»Ð°. ÐÐµÐ· ÑÑÐ¾Ð¹ ÑÑÑÐ¾ÐºÐ¸ Ð¿ÑÐ°Ð¹Ñ Ð¼Ð°ÑÐºÐ¸ Ð±ÐµÐ· ÑÑÐ¾ÐºÐ° Ð·Ð°Ð²ÐµÑÑÐ¸ Ð½ÐµÐ»ÑÐ·Ñ
  // Ð²Ð¾Ð²ÑÐµ, Ð° Ñ Ð¼Ð°ÑÐºÐ¸ ÑÐ¾ ÑÑÐ¾ÐºÐ¾Ð¼ â Ð½ÐµÐ»ÑÐ·Ñ Ð½Ð° Ð¼Ð¾Ð´ÐµÐ»Ñ, ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ Ð² Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸ ÐµÑÑ Ð½ÐµÑ
  const missingModels = useMemo(() => {
    const shown = new Set(tree.map((n) => String(n.fixed.modelId ?? '')));
    return (data?.models || []).filter((m) => !shown.has(String(m.id)));
  }, [tree, data]);

  const onAddModel = (rawId) => {
    const modelId = Number(rawId);
    setApplyConfirm(null);
    setTree((prev) => [...prev, makeNode({ modelId }, data.stock || [], data.rules || [])]);
  };

  const meta = data?.priceList;

  return (
    <>
      <Header title="ÐÑÐ°Ð¹Ñ Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ" icon={icon} />
      <div className={styles.container}>
        <div className={styles.toolbar}>
          <select
            aria-label="ÐÐ°ÑÐºÐ°"
            value={markId || ''}
            onChange={(e) => setMarkId(Number(e.target.value))}
          >
            {/* Ð¡Ð¿Ð¸ÑÐ¾Ðº â Ð²ÐµÑÑ ÐºÐ°ÑÐ°Ð»Ð¾Ð³, Ð° Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ Ð¼Ð°ÑÐºÐ¸ ÑÐ¾ ÑÑÐ¾ÐºÐ¾Ð¼: Ð¿ÑÐ¸ÐºÐ°Ð· Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ
                ÑÐ°Ð½ÑÑÐµ Ð¼Ð°ÑÐ¸Ð½. Ð§Ð¸ÑÐ»Ð¾ ÑÑÐ´Ð¾Ð¼ Ð³Ð¾Ð²Ð¾ÑÐ¸Ñ, Ð³Ð´Ðµ ÑÐµÐ½Ð° ÑÐ¶Ðµ ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ */}
            {marks.map((m) => (
              <option key={m.markId} value={m.markId}>
                {m.mark}
                {m.stock ? ` â ${m.stock} Ð² ÑÑÐ¾ÐºÐµ` : ''}
              </option>
            ))}
          </select>
          {meta && (
            <>
              <input
                placeholder="ÐÐ¾Ð¼ÐµÑ Ð¿ÑÐ¸ÐºÐ°Ð·Ð°"
                defaultValue={meta.docNumber || ''}
                onBlur={(e) => saveMeta({ docNumber: e.target.value })}
              />
              <input
                type="date"
                title="ÐÐ°ÑÐ° Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ° â Ð¾Ð½Ð° Ð¶Ðµ Ð²ÐµÑÑÐ¸Ñ Ð¿ÑÐ°Ð¹ÑÐ°"
                defaultValue={dateInput(meta.docDate)}
                onBlur={(e) => saveMeta({ docDate: e.target.value || null })}
              />
            </>
          )}
        </div>

        {loading ? (
          <div className={styles.empty}>ÐÐ°Ð³ÑÑÐ·ÐºÐ°â¦</div>
        ) : !data ? (
          // ÐÐµÐ· Ð´Ð°Ð½Ð½ÑÑ Ð¿ÑÑÑÐ¾Ðµ Ð´ÐµÑÐµÐ²Ð¾ Ð·Ð½Ð°ÑÐ¸Ð»Ð¾ Ð±Ñ Â«Ñ Ð¼Ð°ÑÐºÐ¸ Ð½ÐµÑ Ð¼Ð°ÑÐ¸Ð½Â», Ð° ÑÑÐ¾ Ð½ÐµÐ¿ÑÐ°Ð²Ð´Ð°
          <div className={styles.empty}>ÐÑÐ°Ð¹Ñ Ð½Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½</div>
        ) : (
          <>
            <div className={styles.stats}>
              <div className={styles.stat}>
                <span>Ð² ÑÑÐ¾ÐºÐµ</span>
                <b>{stats.total}</b>
              </div>
              <div className={styles.stat}>
                <span>Ñ ÑÐµÐ½Ð¾Ð¹</span>
                <b className={styles.ok}>{stats.priced}</b>
              </div>
              <div className={styles.stat}>
                <span>Ð±ÐµÐ· ÑÐµÐ½Ñ</span>
                <b className={stats.withoutPrice ? styles.bad : ''}>{stats.withoutPrice}</b>
              </div>
              <div className={styles.stat}>
                <span>Ð½Ðµ Ð¿Ð¾ Ð¿ÑÐ°Ð¹ÑÑ</span>
                <b>{stats.changing}</b>
              </div>
              {/* ÐÐ°Ð±Ð»Ð¾ÐºÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐµ Ð¼Ð°ÑÐ¸Ð½Ñ Ð²ÑÐ¾Ð´ÑÑ Ð² Â«Ð½Ðµ Ð¿Ð¾ Ð¿ÑÐ°Ð¹ÑÑÂ», Ð½Ð¾ Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ Ð¸Ñ
                  Ð¿ÑÐ¾Ð¿ÑÑÑÐ¸Ñ â Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð¾, ÑÑÐ¾Ð±Ñ ÑÐ°Ð·Ð½Ð¸ÑÐ° Ñ Ð¿ÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ¾Ð¼
                  Ð±ÑÐ»Ð° Ð¾Ð±ÑÑÑÐ½ÐµÐ½Ð°, Ð° Ð½Ðµ Ð²ÑÐ³Ð»ÑÐ´ÐµÐ»Ð° ÑÐ°ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸ÐµÐ¼ */}
              <div className={styles.stat}>
                <span>Ð¸Ð· Ð½Ð¸Ñ Ð² ÑÐ´ÐµÐ»ÐºÐ°Ñ</span>
                <b className={stats.locked ? styles.bad : ''}>{stats.locked}</b>
              </div>
            </div>

            <div className={styles.search}>
              <input
                placeholder="ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ Ð¼Ð¾Ð´ÐµÐ»Ð¸"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              {query && (
                <button type="button" className={styles.mini} onClick={() => setQuery('')}>
                  ÑÐ±ÑÐ¾ÑÐ¸ÑÑ
                </button>
              )}
              <button
                type="button"
                className={styles.mini}
                onClick={() => setOpenPaths(new Set())}
              >
                ÑÐ²ÐµÑÐ½ÑÑÑ Ð²ÑÑ
              </button>
            </div>

            {unrepresentableRules(data?.rules || []).length > 0 && (
              // ÐÑÐ°Ð²Ð¸Ð»Ð¾ Ð½Ð° Ð²ÑÑ Ð¼Ð°ÑÐºÑ Ð² Ð´ÐµÑÐµÐ²Ðµ Ð½Ðµ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÐµÑÑÑ â Ð½Ð¾ Ð¸ Ð½Ðµ ÑÐµÑÑÐµÑÑÑ.
              // ÐÐ¾Ð»ÑÐ°ÑÑ Ð¾ Ð½ÑÐ¼ Ð½ÐµÐ»ÑÐ·Ñ: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð½Ðµ Ð¿Ð¾Ð¹Ð¼ÑÑ, Ð¾ÑÐºÑÐ´Ð° Ñ Ð¼Ð°ÑÐ¸Ð½Ñ ÑÐµÐ½Ð°
              <div className={styles.note}>
                ÐÑÐ°Ð²Ð¸Ð» Ð½Ð° Ð²ÑÑ Ð¼Ð°ÑÐºÑ (Ð²Ð½Ðµ Ð´ÐµÑÐµÐ²Ð°):{' '}
                {unrepresentableRules(data.rules).length}. ÐÐ½Ð¸ ÑÐ¾ÑÑÐ°Ð½ÑÑÑÑÑ, Ð½Ð¾
                ÑÐµÐ´Ð°ÐºÑÐ¸ÑÑÑÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐµÑÐµÐ· Ð±Ð°Ð·Ñ.
              </div>
            )}

            <div className={styles.head}>
              <span className={styles.name}>ÐÐµÑÐºÐ°</span>
              <span className={styles.count}>ÑÑ</span>
              <span className={styles.range}>ÑÐµÐ¹ÑÐ°Ñ</span>
              <span className={styles.headPrice}>Ð½Ð¾Ð²Ð°Ñ ÑÐµÐ½Ð°</span>
              <span className={styles.control} />
            </div>
            {visibleTree.length ? (
              visibleTree.map((n) => renderNode(n, 0, null))
            ) : query.trim() ? (
              <div className={styles.empty}>ÐÐ¾ Ð·Ð°Ð¿ÑÐ¾ÑÑ Â«{query}Â» Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð¾</div>
            ) : (
              <div className={styles.empty}>Ð£ ÑÑÐ¾Ð¹ Ð¼Ð°ÑÐºÐ¸ Ð½ÐµÑ Ð¼Ð°ÑÐ¸Ð½ Ð² ÑÑÐ¾ÐºÐµ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ</div>
            )}
            {!query.trim() && missingModels.length > 0 && (
              <div className={styles.addRow} style={{ paddingLeft: 22 }}>
                <select
                  className={styles.split}
                  aria-label="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ"
                  value=""
                  onChange={(e) => e.target.value && onAddModel(e.target.value)}
                >
                  <option value="">+ Ð¼Ð¾Ð´ÐµÐ»Ñ, ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ Ð½ÐµÑ Ð² ÑÑÐ¾ÐºÐµâ¦</option>
                  {missingModels.map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {preview && (
              <div className={styles.preview}>
                <div>Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑÑ Ð¼Ð°ÑÐ¸Ð½ â {preview.changed}</div>
                <div>ÑÐ¶Ðµ ÑÐ¾Ð²Ð¿Ð°Ð´Ð°ÐµÑ â {preview.unchanged}</div>
                <div>Ð² ÐºÐ¾ÑÐ·Ð¸Ð½Ð°Ñ Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð² â {preview.inCart}, ÑÐ¼ÐµÐ½Ð¸Ð¼ Ð¸ Ð·Ð°Ð¿Ð¸ÑÐµÐ¼ Ð² Ð¸ÑÑÐ¾ÑÐ¸Ñ ÑÐ´ÐµÐ»ÐºÐ¸</div>
                <div className={preview.skippedLocked ? styles.bad : ''}>
                  Ð² ÑÐ´ÐµÐ»ÐºÐ°Ñ Ñ Ð·Ð°ÑÐ²ÐºÐ¾Ð¹ Ð² Ð±Ð°Ð½Ðº â {preview.skippedLocked}, Ð¿ÑÐ¾Ð¿ÑÑÑÐ¸Ð¼
                  {preview.lockedVins?.length ? `: ${preview.lockedVins.join(', ')}` : ''}
                </div>
                <div className={preview.noRule ? styles.bad : ''}>
                  Ð±ÐµÐ· Ð¿ÑÐ°Ð²Ð¸Ð»Ð° â {preview.noRule}
                </div>
              </div>
            )}

            <div className={styles.actions}>
              <Button text="Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¿ÑÐ°Ð¹Ñ" onClick={saveRules} disabled={busy} fill />
              <Button text="ÐÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ" onClick={runPreview} disabled={busy} />
              <Button
                text={
                  applyConfirm
                    ? `ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ ${applyConfirm.changed} Ð¼Ð°ÑÐ¸Ð½?`
                    : 'ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ Ðº ÑÑÐ¾ÐºÑ'
                }
                onClick={runApply}
                disabled={busy || (applyConfirm && applyConfirm.changed === 0)}
                style={applyConfirm ? { borderColor: '#d84a4a', color: '#d84a4a' } : {}}
              />
              {appliedBatch && (
                <Button text="ÐÑÐºÐ°ÑÐ¸ÑÑ" onClick={runRollback} disabled={busy} />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PriceList;
